import type { ButtonHTMLAttributes } from "preact";
import { cx } from "../cx";
import { Spinner } from "./Spinner";

export type ButtonVariant = "primary" | "secondary" | "ghost" | "danger";

export interface ButtonProps
  extends Omit<ButtonHTMLAttributes<HTMLButtonElement>, "size" | "disabled" | "class" | "className" | "type"> {
  variant?: ButtonVariant;
  size?: "sm" | "md" | "lg";
  /** Shows a spinner, keeps the label's width (no layout shift) and blocks clicks. */
  busy?: boolean;
  disabled?: boolean;
  full?: boolean;
  type?: "button" | "submit";
  class?: string;
}

export function Button({
  variant = "secondary",
  size = "md",
  busy = false,
  disabled = false,
  full = false,
  type = "button",
  class: cls,
  children,
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      type={type}
      class={cx("btn", `btn--${variant}`, `btn--${size}`, full && "btn--full", busy && "is-busy", cls)}
      disabled={disabled || busy}
      aria-busy={busy || undefined}
      data-nav=""
    >
      <span class="btn__label">{children}</span>
      {busy && <Spinner class="btn__spinner" size={16} />}
    </button>
  );
}
